import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { countryState } from "../../recoil-atoms/webSiteAtoms";
import { useSetRecoilState } from "recoil";
import {
  countryPromise,
  cartUpdatePromise,
} from "./Checkout/components/promessesAxios";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  const setCountry = useSetRecoilState(countryState);

  useEffect(() => {
    // Vérifie la présence du token dans les cookies au montage et toutes les minutes
    const interval = setInterval(() => {
      const token = Cookies.get("auth_token");
      if (!token) {
        logout();
      }
    }, 60000); // 60 secondes

    //deconnexion provoquée au montage pour retirer tout token déjà présent
    logout();

    return () => clearInterval(interval); // nettoyage
  }, []);

  const login = async (token) => {
    //RECUPERATION DU PAYS DE L'UTILISATEUR
    const countryResponse = await countryPromise(token);
    if (!countryResponse.success) {
      console.error(countryResponse);
      return countryResponse;
    }
    setCountry(countryResponse.country);

    //UPDATE CART EN BDD
    const cart = { cart: JSON.parse(localStorage.getItem("productsCart")) };
    const cartUpdateResponse = await cartUpdatePromise(token, cart);
    if (!cartUpdateResponse.success) {
      console.error(cartUpdateResponse);
      return cartUpdateResponse;
    }
    Cookies.set("auth_token", token, {
      secure: true,
      sameSite: "Strict",
      expires: 2 / 24, // = 2 heures
    });
    setIsAuthenticated(true);
    return { success: true };
  };

  const loginAdmin = (token, roles, username) => {
    Cookies.set("auth_token", token, {
      secure: true,
      sameSite: "Strict",
      expires: 2 / 24, // = 2 heures
    });
    Cookies.set("auth_roles", roles, {
      secure: true,
      sameSite: "Strict",
      expires: 2 / 24, // = 2 heures
    });
    Cookies.set("auth_name", username, {
      secure: true,
      sameSite: "Strict",
      expires: 2 / 24, // = 2 heures
    });
    setIsAdminAuthenticated(true);
  };

  const logout = () => {
    Cookies.remove("auth_token");
    setIsAuthenticated(false);

    Cookies.remove("auth_roles");
    Cookies.remove("auth_name");
    setIsAdminAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        loginAdmin,
        logout,
        isAdminAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useAuth = () => useContext(AuthContext);
